import React, { useState, useEffect, useRef } from "react";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";
import "../../../assets/css/student/MyAssignments.css";

// ─── SVG ICON SET ────────────────────────────────────────────────────────────
const Icons = {
  Pending: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Submitted: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Reviewed: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Approved: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  List: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  Card: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  Workflow: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <rect x="2" y="3" width="5" height="18" rx="1" />
      <rect x="9.5" y="3" width="5" height="18" rx="1" />
      <rect x="17" y="3" width="5" height="18" rx="1" />
    </svg>
  ),
  Close: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Calendar: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Mentor: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  AI: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Arrow: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  Upload: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  GitHub: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
    </svg>
  ),
  Check: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  ChevronRight: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  Flag: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
      <line x1="4" y1="22" x2="4" y2="15" />
    </svg>
  ),
  Send: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Paperclip: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  ),
  Trash: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  ),
  SuccessTick: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
};

// ─── DATA ────────────────────────────────────────────────────────────────────
const ASSIGNMENTS = [
  {
    id: 1,
    title: "Build a Portfolio Website",
    course: "Web Development",
    mentor: "Sarah Chen",
    dueDate: "2026-01-20",
    status: "pending",
    priority: "high",
    description:
      "Create a fully responsive portfolio website showcasing your projects. Must include hero section, project gallery, and contact form.",
    requirements: [
      "Responsive layout using CSS Grid/Flexbox",
      "At least 4 project showcases",
      "Contact form with validation",
      "Deployed to a live URL",
    ],
    score: null,
    feedback: null,
    progress: 0,
    aiHint:
      "Your CSS fundamentals are strong — focus on mobile-first approach for best results.",
  },
  {
    id: 2,
    title: "Responsive Landing Page",
    course: "Web Development",
    mentor: "Sarah Chen",
    dueDate: "2026-01-22",
    status: "submitted",
    priority: "medium",
    description:
      "Design and develop a modern SaaS landing page with conversion-focused layout.",
    requirements: [
      "Hero with CTA button",
      "Feature comparison section",
      "Testimonials block",
      "Mobile responsive",
    ],
    score: null,
    feedback:
      "Great layout structure! Work on improving the CTA button contrast and font hierarchy.",
    progress: 100,
    aiHint: "This aligns with your UI design track — great timing.",
  },
  {
    id: 3,
    title: "HTML5 Semantic Structure",
    course: "Web Development",
    mentor: "Sarah Chen",
    dueDate: "2026-01-10",
    status: "approved",
    priority: "low",
    description:
      "Create a well-structured HTML5 document using only semantic elements.",
    requirements: [
      "Use header, main, section, article, aside, footer",
      "Proper heading hierarchy",
      "ARIA labels where applicable",
    ],
    score: 91,
    feedback:
      "Excellent semantic understanding. Your use of ARIA labels was impressive.",
    progress: 100,
    aiHint: "This mastery will accelerate your accessibility journey.",
  },
  {
    id: 4,
    title: "JavaScript Calculator",
    course: "JavaScript",
    mentor: "James Owusu",
    dueDate: "2026-01-18",
    status: "reviewed",
    priority: "high",
    description:
      "Build a functional calculator with all basic arithmetic operations, keyboard support, and history log.",
    requirements: [
      "All basic operations",
      "Keyboard input support",
      "History panel (last 10 operations)",
      "Error handling for division by zero",
    ],
    score: 78,
    feedback:
      "Good logic flow but async handling of edge cases needs work. Revisit the divide-by-zero guard.",
    progress: 100,
    aiHint:
      "You are likely to improve score by fixing your async edge case handling in divide operations.",
  },
  {
    id: 5,
    title: "Array Methods Practice",
    course: "JavaScript",
    mentor: "James Owusu",
    dueDate: "2026-01-15",
    status: "approved",
    priority: "low",
    description:
      "Complete all exercises on modern array methods: map, filter, reduce, flatMap, and more.",
    requirements: [
      "10 exercises completed",
      "No for-loops allowed",
      "Unit tests written",
    ],
    score: 95,
    feedback:
      "Exceptional work. Your reduce implementation was creative and efficient.",
    progress: 100,
    aiHint: null,
  },
  {
    id: 6,
    title: "DOM Manipulation Project",
    course: "JavaScript",
    mentor: "James Owusu",
    dueDate: "2026-01-25",
    status: "inprogress",
    priority: "high",
    description:
      "Create a dynamic task manager using only vanilla JS DOM APIs — no frameworks.",
    requirements: [
      "Add/edit/delete tasks",
      "Drag and drop reordering",
      "LocalStorage persistence",
      "Search and filter",
    ],
    score: null,
    feedback: null,
    progress: 45,
    aiHint:
      "Based on your JavaScript progress, this should take you ~6 hours. Start with the data model.",
  },
  {
    id: 7,
    title: "React Todo App",
    course: "React",
    mentor: "Priya Nair",
    dueDate: "2026-01-25",
    status: "pending",
    priority: "high",
    description:
      "Build a feature-rich todo application using React hooks and context API.",
    requirements: [
      "useState & useEffect",
      "Context API for global state",
      "Filter by status",
      "Persisted with localStorage",
    ],
    score: null,
    feedback: null,
    progress: 0,
    aiHint:
      "This assignment aligns with your React roadmap — completing it unlocks the Redux module.",
  },
  {
    id: 8,
    title: "CSS Flexbox Layout",
    course: "CSS",
    mentor: "Sarah Chen",
    dueDate: "2026-01-15",
    status: "approved",
    priority: "low",
    description: "Create a complex responsive layout using only CSS Flexbox.",
    requirements: [
      "Sidebar + main layout",
      "Responsive breakpoints",
      "No CSS Grid allowed",
    ],
    score: 88,
    feedback:
      "Solid understanding of flex properties. Consider using gap instead of margins for cleaner spacing.",
    progress: 100,
    aiHint: null,
  },
  {
    id: 9,
    title: "REST API Development",
    course: "Node.js",
    mentor: "Marcus Webb",
    dueDate: "2026-01-30",
    status: "pending",
    priority: "medium",
    description:
      "Build a full CRUD REST API using Express.js with proper error handling and middleware.",
    requirements: [
      "Express router setup",
      "CRUD for /users and /posts",
      "Input validation middleware",
      "Error handling middleware",
      "Postman collection included",
    ],
    score: null,
    feedback: null,
    progress: 0,
    aiHint:
      "Your async/await mastery from JavaScript will make this feel natural.",
  },
  {
    id: 10,
    title: "Database Schema Design",
    course: "Database",
    mentor: "Lisa Tran",
    dueDate: "2026-01-24",
    status: "submitted",
    priority: "medium",
    description:
      "Design a normalized database schema for a multi-vendor e-commerce platform.",
    requirements: [
      "ER diagram",
      "At least 3NF normalization",
      "Indexes on foreign keys",
      "SQL seed file included",
    ],
    score: null,
    feedback: null,
    progress: 100,
    aiHint:
      "Your schema thinking will directly feed into the backend API module next week.",
  },
];

const STATUS_CONFIG = {
  pending: {
    label: "Pending",
    color: "#f59e0b",
    bg: "rgba(245,158,11,0.1)",
    dot: "#f59e0b",
  },
  inprogress: {
    label: "In Progress",
    color: "#3b82f6",
    bg: "rgba(59,130,246,0.1)",
    dot: "#3b82f6",
  },
  submitted: {
    label: "Submitted",
    color: "#8b5cf6",
    bg: "rgba(139,92,246,0.1)",
    dot: "#8b5cf6",
  },
  reviewed: {
    label: "Reviewed",
    color: "#f97316",
    bg: "rgba(249,115,22,0.1)",
    dot: "#f97316",
  },
  approved: {
    label: "Approved",
    color: "#10b981",
    bg: "rgba(16,185,129,0.1)",
    dot: "#10b981",
  },
};

const PRIORITY_CONFIG = {
  high: { label: "High", color: "#ef4444" },
  medium: { label: "Medium", color: "#f59e0b" },
  low: { label: "Low", color: "#10b981" },
};

const KANBAN_COLUMNS = [
  "pending",
  "inprogress",
  "submitted",
  "reviewed",
  "approved",
];

// ─── HELPERS ─────────────────────────────────────────────────────────────────
function daysUntil(dateStr) {
  const diff = new Date(dateStr) - new Date();
  return Math.ceil(diff / 86400000);
}

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function canSubmit(status) {
  return status === "pending" || status === "inprogress";
}

// ─── KPI WIDGET ──────────────────────────────────────────────────────────────
function KPIWidget({ icon: Icon, label, value, accent }) {
  return (
    <div className="kpi-card" style={{ "--accent": accent }}>
      <div className="kpi-icon-wrap">
        <Icon />
      </div>
      <div className="kpi-body">
        <span className="kpi-value">{value}</span>
        <span className="kpi-label">{label}</span>
      </div>
      <div className="kpi-bar" />
    </div>
  );
}

// ─── STATUS BADGE ────────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  return (
    <span
      className="status-badge"
      style={{ color: cfg.color, background: cfg.bg }}
    >
      <span className="status-dot" style={{ background: cfg.dot }} />
      {cfg.label}
    </span>
  );
}

// ─── PRIORITY CHIP ───────────────────────────────────────────────────────────
function PriorityChip({ priority }) {
  const cfg = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;
  return (
    <span
      className="priority-chip"
      style={{ color: cfg.color, borderColor: `${cfg.color}40` }}
    >
      <span className="pchip-icon" style={{ color: cfg.color }}>
        <Icons.Flag />
      </span>
      {cfg.label}
    </span>
  );
}

// ─── AI HINT ─────────────────────────────────────────────────────────────────
function AIHint({ text }) {
  if (!text) return null;
  return (
    <div className="ai-hint">
      <span className="ai-hint-icon">
        <Icons.AI />
      </span>
      <span>{text}</span>
    </div>
  );
}

// ─── DEADLINE CHIP ───────────────────────────────────────────────────────────
function DeadlineChip({ dueDate }) {
  const days = daysUntil(dueDate);
  const urgent = days >= 0 && days <= 1;
  const overdue = days < 0;
  return (
    <span
      className={`deadline-chip ${urgent ? "urgent" : overdue ? "overdue" : ""}`}
    >
      <Icons.Calendar />
      {overdue
        ? `${Math.abs(days)}d overdue`
        : days === 0
          ? "Due today"
          : `${days}d left`}
    </span>
  );
}

// ─── SUBMIT ASSIGNMENT MODAL ──────────────────────────────────────────────────
function SubmitAssignmentModal({ assignment, onClose, onSubmitSuccess }) {
  const [title, setTitle] = useState(assignment?.title || "");
  const [note, setNote] = useState("");
  const [githubLink, setGithubLink] = useState("");
  const [files, setFiles] = useState([]);
  const [mentor, setMentor] = useState(assignment?.mentor || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const overlayRef = useRef(null);
  const fileInputRef = useRef(null);

  const mentors = [...new Set(ASSIGNMENTS.map((a) => a.mentor))];

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const dropped = Array.from(e.dataTransfer.files);
    setFiles((prev) => [...prev, ...dropped]);
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleSubmit = async () => {
    if (!title.trim() || !mentor) return;
    setIsSubmitting(true);
    // Simulate API call
    await new Promise((r) => setTimeout(r, 1800));
    setIsSubmitting(false);
    setSubmitted(true);
    setTimeout(() => {
      onSubmitSuccess && onSubmitSuccess(assignment?.id);
      onClose();
    }, 2200);
  };

  const isValid = title.trim() && mentor;

  if (!assignment) return null;

  return (
    <div
      className="modal-overlay submit-modal-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
    >
      <div className="submit-modal-panel">
        {/* Success State */}
        {submitted && (
          <div className="submit-success-state">
            <div className="success-icon-wrap">
              <Icons.SuccessTick />
            </div>
            <h3>Assignment Submitted!</h3>
            <p>
              Your work has been sent to <strong>{mentor}</strong> for review.
            </p>
          </div>
        )}

        {/* Normal State */}
        {!submitted && (
          <>
            {/* Header */}
            <div className="submit-modal-header">
              <div className="submit-modal-header-left">
                <div className="submit-modal-icon">
                  <Icons.Send />
                </div>
                <div>
                  <h2 className="submit-modal-title">Submit Assignment</h2>
                  <p className="submit-modal-subtitle">
                    Fill in the details and send to your mentor
                  </p>
                </div>
              </div>
              <button className="modal-close-btn" onClick={onClose}>
                <Icons.Close />
              </button>
            </div>

            {/* Assignment Info Banner */}
            <div className="submit-assignment-banner">
              <div className="submit-banner-course">{assignment.course}</div>
              <div className="submit-banner-title">{assignment.title}</div>
              <div className="submit-banner-meta">
                <span>
                  <Icons.Calendar />
                  {formatDate(assignment.dueDate)}
                </span>
                <DeadlineChip dueDate={assignment.dueDate} />
                <PriorityChip priority={assignment.priority} />
              </div>
            </div>

            {/* Form Body */}
            <div className="submit-modal-body">
              {/* Assignment Title */}
              <div className="submit-field">
                <label className="submit-label">
                  Assignment Title <span className="req-star">*</span>
                </label>
                <input
                  className="submit-input"
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter assignment title..."
                />
              </div>

              {/* Mentor Selection */}
              <div className="submit-field">
                <label className="submit-label">
                  Send To (Mentor) <span className="req-star">*</span>
                </label>
                <div className="mentor-select-grid">
                  {mentors.map((m) => (
                    <button
                      key={m}
                      className={`mentor-select-btn ${mentor === m ? "active" : ""}`}
                      onClick={() => setMentor(m)}
                    >
                      <span className="mentor-avatar-sm">
                        {m
                          .split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </span>
                      <span>{m}</span>
                      {mentor === m && (
                        <span className="mentor-check">
                          <Icons.Check />
                        </span>
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* Description / Notes */}
              <div className="submit-field">
                <label className="submit-label">Your Notes / Approach</label>
                <textarea
                  className="submit-textarea"
                  rows={5}
                  placeholder="Describe your approach, key decisions made, challenges faced, or anything you'd like your mentor to know..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>

              {/* GitHub Link */}
              <div className="submit-field">
                <label className="submit-label">GitHub Repository</label>
                <div className="github-input-wrap">
                  <span className="github-icon">
                    <Icons.GitHub />
                  </span>
                  <input
                    className="github-input"
                    type="text"
                    placeholder="https://github.com/yourusername/repo"
                    value={githubLink}
                    onChange={(e) => setGithubLink(e.target.value)}
                  />
                </div>
              </div>

              {/* File Upload */}
              <div className="submit-field">
                <label className="submit-label">Upload Files</label>
                <div
                  className={`upload-zone ${dragOver ? "drag-active" : ""}`}
                  onDragOver={(e) => {
                    e.preventDefault();
                    setDragOver(true);
                  }}
                  onDragLeave={() => setDragOver(false)}
                  onDrop={handleDrop}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept=".zip,.pdf,.png,.jpg,.jpeg,.txt,.js,.jsx,.ts,.tsx,.html,.css"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <div className="upload-zone-icon">
                    <Icons.Paperclip />
                  </div>
                  <span className="upload-zone-text">
                    Drop files here or <strong>click to browse</strong>
                  </span>
                  <span className="upload-hint">
                    ZIP, PDF, PNG, JS, HTML, CSS — max 50MB each
                  </span>
                </div>

                {/* File List */}
                {files.length > 0 && (
                  <div className="file-list">
                    {files.map((file, idx) => (
                      <div key={idx} className="file-item">
                        <span className="file-icon">
                          <Icons.Paperclip />
                        </span>
                        <div className="file-info">
                          <span className="file-name">{file.name}</span>
                          <span className="file-size">
                            {formatFileSize(file.size)}
                          </span>
                        </div>
                        <button
                          className="file-remove-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFile(idx);
                          }}
                        >
                          <Icons.Trash />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Footer Actions */}
            <div className="submit-modal-footer">
              <button className="submit-cancel-btn" onClick={onClose}>
                Cancel
              </button>
              <button
                className={`submit-confirm-btn ${isSubmitting ? "loading" : ""} ${!isValid ? "disabled" : ""}`}
                onClick={handleSubmit}
                disabled={!isValid || isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="submit-spinner" />
                    Submitting...
                  </>
                ) : (
                  <>
                    <Icons.Send />
                    Submit Assignment
                  </>
                )}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─── LIST ROW ────────────────────────────────────────────────────────────────
function AssignmentRow({ assignment, onOpen, onSubmit }) {
  return (
    <div className="list-row" onClick={() => onOpen(assignment)}>
      <div className="list-row-main">
        <div className="list-row-title">
          <span>{assignment.title}</span>
          {assignment.aiHint && (
            <span className="ai-dot" title={assignment.aiHint}>
              <Icons.AI />
            </span>
          )}
        </div>
        <div className="list-row-meta">
          <span className="meta-item">
            <Icons.Mentor />
            {assignment.mentor}
          </span>
          <span className="meta-sep" />
          <span className="meta-item course-tag">{assignment.course}</span>
        </div>
      </div>
      <div className="list-row-right">
        <DeadlineChip dueDate={assignment.dueDate} />
        <PriorityChip priority={assignment.priority} />
        <StatusBadge status={assignment.status} />
        {canSubmit(assignment.status) && (
          <button
            className="row-submit-btn"
            onClick={(e) => {
              e.stopPropagation();
              onSubmit(assignment);
            }}
            title="Submit this assignment"
          >
            <Icons.Send />
            Submit
          </button>
        )}
        <button
          className="row-action-btn"
          onClick={(e) => {
            e.stopPropagation();
            onOpen(assignment);
          }}
        >
          Open <Icons.ChevronRight />
        </button>
      </div>
    </div>
  );
}

// ─── ASSIGNMENT CARD ─────────────────────────────────────────────────────────
function AssignmentCard({ assignment, onOpen, onSubmit }) {
  const cfg = STATUS_CONFIG[assignment.status] || STATUS_CONFIG.pending;
  return (
    <div
      className="assignment-card"
      onClick={() => onOpen(assignment)}
      style={{ "--card-accent": cfg.color }}
    >
      <div className="card-top-bar" style={{ background: cfg.color }} />
      <div className="card-header">
        <span className="card-course-tag">{assignment.course}</span>
        <PriorityChip priority={assignment.priority} />
      </div>
      <h3 className="card-title">{assignment.title}</h3>
      <p className="card-desc">{assignment.description.substring(0, 80)}…</p>
      {assignment.progress > 0 && (
        <div className="card-progress">
          <div className="progress-bar-bg">
            <div
              className="progress-bar-fill"
              style={{
                width: `${assignment.progress}%`,
                background: cfg.color,
              }}
            />
          </div>
          <span className="progress-label">{assignment.progress}%</span>
        </div>
      )}
      {assignment.aiHint && <AIHint text={assignment.aiHint} />}
      <div className="card-footer">
        <span className="card-mentor">
          <Icons.Mentor />
          {assignment.mentor}
        </span>
        <DeadlineChip dueDate={assignment.dueDate} />
      </div>
      <div className="card-status-row">
        <StatusBadge status={assignment.status} />
        <div className="card-actions">
          {canSubmit(assignment.status) && (
            <button
              className="card-submit-btn"
              onClick={(e) => {
                e.stopPropagation();
                onSubmit(assignment);
              }}
              title="Submit assignment"
            >
              <Icons.Send />
              Submit
            </button>
          )}
          <button className="card-open-btn">
            View <Icons.Arrow />
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── KANBAN COLUMN ───────────────────────────────────────────────────────────
function KanbanColumn({ status, assignments, onOpen, onSubmit }) {
  const cfg = STATUS_CONFIG[status];
  return (
    <div className="kanban-col">
      <div className="kanban-col-header" style={{ "--col-color": cfg.color }}>
        <span className="kanban-col-dot" style={{ background: cfg.color }} />
        <span className="kanban-col-label">{cfg.label}</span>
        <span className="kanban-col-count">{assignments.length}</span>
      </div>
      <div className="kanban-col-body">
        {assignments.length === 0 && (
          <div className="kanban-empty">No assignments here</div>
        )}
        {assignments.map((a) => (
          <div key={a.id} className="kanban-card" onClick={() => onOpen(a)}>
            <div className="kanban-card-title">{a.title}</div>
            <div className="kanban-card-course">{a.course}</div>
            {a.aiHint && (
              <div className="kanban-ai-hint">
                <Icons.AI />
                <span>{a.aiHint.substring(0, 55)}…</span>
              </div>
            )}
            <div className="kanban-card-footer">
              <DeadlineChip dueDate={a.dueDate} />
              <PriorityChip priority={a.priority} />
            </div>
            {canSubmit(a.status) && (
              <button
                className="kanban-submit-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onSubmit(a);
                }}
              >
                <Icons.Send /> Submit
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── ASSIGNMENT MODAL ────────────────────────────────────────────────────────
function AssignmentModal({ assignment, onClose, onSubmit }) {
  const [tab, setTab] = useState("details");
  const [githubLink, setGithubLink] = useState("");
  const [note, setNote] = useState("");
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  if (!assignment) return null;
  const cfg = STATUS_CONFIG[assignment.status] || STATUS_CONFIG.pending;

  return (
    <div
      className="modal-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
    >
      <div className="modal-panel">
        {/* Header */}
        <div className="modal-header" style={{ "--modal-accent": cfg.color }}>
          <div
            className="modal-header-accent"
            style={{ background: cfg.color }}
          />
          <div className="modal-header-content">
            <div className="modal-header-top">
              <span className="modal-course-tag">{assignment.course}</span>
              <div className="modal-header-actions">
                {canSubmit(assignment.status) && (
                  <button
                    className="modal-submit-quick-btn"
                    onClick={() => {
                      onClose();
                      onSubmit(assignment);
                    }}
                    title="Submit this assignment"
                  >
                    <Icons.Send />
                    Submit Assignment
                  </button>
                )}
                <button className="modal-close-btn" onClick={onClose}>
                  <Icons.Close />
                </button>
              </div>
            </div>
            <h2 className="modal-title">{assignment.title}</h2>
            <div className="modal-meta-row">
              <span className="modal-meta-item">
                <Icons.Mentor />
                {assignment.mentor}
              </span>
              <span className="modal-meta-item">
                <Icons.Calendar />
                {formatDate(assignment.dueDate)}
              </span>
              <StatusBadge status={assignment.status} />
              <PriorityChip priority={assignment.priority} />
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="modal-tabs">
          {["details", "submit", "feedback"].map((t) => (
            <button
              key={t}
              className={`modal-tab ${tab === t ? "active" : ""}`}
              onClick={() => setTab(t)}
              style={tab === t ? { "--tab-color": cfg.color } : {}}
            >
              {t === "details"
                ? "Assignment Details"
                : t === "submit"
                  ? "Submit Work"
                  : "Mentor Feedback"}
            </button>
          ))}
        </div>

        {/* Body */}
        <div className="modal-body">
          {tab === "details" && (
            <div className="tab-content">
              <div className="modal-section">
                <h4 className="modal-section-title">Instructions</h4>
                <p className="modal-desc">{assignment.description}</p>
              </div>
              <div className="modal-section">
                <h4 className="modal-section-title">Requirements</h4>
                <ul className="req-list">
                  {assignment.requirements.map((r, i) => (
                    <li key={i} className="req-item">
                      <span className="req-check" style={{ color: cfg.color }}>
                        <Icons.Check />
                      </span>
                      {r}
                    </li>
                  ))}
                </ul>
              </div>
              {assignment.aiHint && (
                <div className="modal-section">
                  <h4 className="modal-section-title">AI Insight</h4>
                  <AIHint text={assignment.aiHint} />
                </div>
              )}
              {assignment.progress > 0 && (
                <div className="modal-section">
                  <h4 className="modal-section-title">Progress</h4>
                  <div className="modal-progress">
                    <div className="progress-bar-bg wide">
                      <div
                        className="progress-bar-fill"
                        style={{
                          width: `${assignment.progress}%`,
                          background: cfg.color,
                        }}
                      />
                    </div>
                    <span className="progress-label">
                      {assignment.progress}% complete
                    </span>
                  </div>
                </div>
              )}
              {/* Submit CTA in details tab */}
              {canSubmit(assignment.status) && (
                <div className="modal-section">
                  <div className="details-submit-cta">
                    <div className="cta-text">
                      <strong>Ready to submit?</strong>
                      <span>
                        Send your work to {assignment.mentor} for review.
                      </span>
                    </div>
                    <button
                      className="cta-submit-btn"
                      style={{ background: cfg.color }}
                      onClick={() => {
                        onClose();
                        onSubmit(assignment);
                      }}
                    >
                      <Icons.Send />
                      Submit Now
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {tab === "submit" && (
            <div className="tab-content">
              {canSubmit(assignment.status) ? (
                <>
                  <div className="modal-submit-redirect">
                    <div className="modal-submit-redirect-icon">
                      <Icons.Send />
                    </div>
                    <p>
                      Use the dedicated submission form for the best experience.
                    </p>
                    <button
                      className="submit-btn"
                      style={{ background: cfg.color }}
                      onClick={() => {
                        onClose();
                        onSubmit(assignment);
                      }}
                    >
                      Open Submit Form <Icons.Arrow />
                    </button>
                  </div>
                  <div className="modal-section" style={{ marginTop: "16px" }}>
                    <h4 className="modal-section-title">
                      Quick Notes (optional)
                    </h4>
                    <textarea
                      className="submit-textarea"
                      rows={5}
                      placeholder="Add a note for your mentor..."
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </div>
                  <div className="modal-section">
                    <h4 className="modal-section-title">GitHub Repository</h4>
                    <div className="github-input-wrap">
                      <span className="github-icon">
                        <Icons.GitHub />
                      </span>
                      <input
                        className="github-input"
                        type="text"
                        placeholder="https://github.com/yourusername/repo"
                        value={githubLink}
                        onChange={(e) => setGithubLink(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-section">
                    <h4 className="modal-section-title">Upload Files</h4>
                    <div className="upload-zone">
                      <Icons.Upload />
                      <span>
                        Drop files here or <strong>browse</strong>
                      </span>
                      <span className="upload-hint">
                        Supports ZIP, PDF, PNG — max 50MB
                      </span>
                    </div>
                  </div>
                  <button
                    className="submit-btn"
                    style={{ background: cfg.color }}
                    onClick={() => {
                      onClose();
                      onSubmit(assignment);
                    }}
                  >
                    Submit Assignment <Icons.Arrow />
                  </button>
                </>
              ) : (
                <div className="feedback-empty">
                  <Icons.Submitted />
                  <p>This assignment has already been submitted.</p>
                </div>
              )}
            </div>
          )}

          {tab === "feedback" && (
            <div className="tab-content">
              {assignment.score !== null ? (
                <>
                  <div
                    className="feedback-score-card"
                    style={{ "--score-color": cfg.color }}
                  >
                    <div
                      className="score-ring"
                      style={{ "--score-color": cfg.color }}
                    >
                      <span className="score-value">{assignment.score}</span>
                      <span className="score-unit">/100</span>
                    </div>
                    <div className="score-meta">
                      <span className="score-grade">
                        {assignment.score >= 90
                          ? "Excellent"
                          : assignment.score >= 75
                            ? "Good"
                            : "Needs Work"}
                      </span>
                      <StatusBadge status={assignment.status} />
                    </div>
                  </div>
                  <div className="modal-section">
                    <h4 className="modal-section-title">Mentor Comments</h4>
                    <div className="feedback-bubble">
                      <div className="feedback-mentor-avatar">
                        <Icons.Mentor />
                      </div>
                      <div className="feedback-text">
                        <strong>{assignment.mentor}</strong>
                        <p>{assignment.feedback}</p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="feedback-empty">
                  <Icons.Reviewed />
                  <p>
                    Mentor feedback will appear here once your submission is
                    reviewed.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── VIEW SWITCHER ────────────────────────────────────────────────────────────
function ViewSwitcher({ view, setView }) {
  const views = [
    { id: "list", label: "List", Icon: Icons.List },
    { id: "card", label: "Cards", Icon: Icons.Card },
    { id: "workflow", label: "Workflow", Icon: Icons.Workflow },
  ];
  return (
    <div className="view-switcher">
      {views.map(({ id, label, Icon }) => (
        <button
          key={id}
          className={`view-btn ${view === id ? "active" : ""}`}
          onClick={() => setView(id)}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function MyAssignments() {
  const [view, setView] = useState("list");
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [submitAssignment, setSubmitAssignment] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");

  const filtered =
    filterStatus === "all"
      ? ASSIGNMENTS
      : ASSIGNMENTS.filter((a) => a.status === filterStatus);

  const kpis = [
    {
      icon: Icons.Pending,
      label: "Pending",
      value: ASSIGNMENTS.filter((a) => a.status === "pending").length,
      accent: "#f59e0b",
    },
    {
      icon: Icons.Submitted,
      label: "Submitted",
      value: ASSIGNMENTS.filter((a) => a.status === "submitted").length,
      accent: "#8b5cf6",
    },
    {
      icon: Icons.Reviewed,
      label: "Reviewed",
      value: ASSIGNMENTS.filter((a) => a.status === "reviewed").length,
      accent: "#f97316",
    },
    {
      icon: Icons.Approved,
      label: "Approved",
      value: `${Math.round((ASSIGNMENTS.filter((a) => a.status === "approved").length / ASSIGNMENTS.length) * 100)}%`,
      accent: "#10b981",
    },
  ];

  const handleOpenSubmit = (assignment) => {
    setSelectedAssignment(null);
    setSubmitAssignment(assignment);
  };

  return (
    <MyStudentLayout>
      <div className="assignments-root">
        {/* Header */}
        <div className="page-header">
          <div className="page-header-text">
            <h1 className="page-title">My Assignments</h1>
            <p className="page-subtitle">
              Complete tasks and get mentor feedback
            </p>
          </div>
          <ViewSwitcher view={view} setView={setView} />
        </div>

        {/* KPI Row */}
        <div className="kpi-row">
          {kpis.map((k, i) => (
            <KPIWidget key={i} {...k} />
          ))}
        </div>

        {/* Filters */}
        <div className="filters-bar">
          <div className="filter-chips">
            {["all", ...Object.keys(STATUS_CONFIG)].map((s) => (
              <button
                key={s}
                className={`filter-chip ${filterStatus === s ? "active" : ""}`}
                onClick={() => setFilterStatus(s)}
                style={
                  filterStatus === s && s !== "all"
                    ? {
                        background: STATUS_CONFIG[s]?.color,
                        color: "#fff",
                        borderColor: STATUS_CONFIG[s]?.color,
                      }
                    : {}
                }
              >
                {s === "all" ? "All" : STATUS_CONFIG[s].label}
                <span className="chip-count">
                  {s === "all"
                    ? ASSIGNMENTS.length
                    : ASSIGNMENTS.filter((a) => a.status === s).length}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Views */}
        <div className={`view-container view-${view}`}>
          {view === "list" && (
            <div className="list-view">
              <div className="list-header-row">
                <span>Assignment</span>
                <span>Due</span>
                <span>Priority</span>
                <span>Status</span>
                <span>Actions</span>
              </div>
              {filtered.map((a) => (
                <AssignmentRow
                  key={a.id}
                  assignment={a}
                  onOpen={setSelectedAssignment}
                  onSubmit={handleOpenSubmit}
                />
              ))}
            </div>
          )}

          {view === "card" && (
            <div className="card-grid">
              {filtered.map((a) => (
                <AssignmentCard
                  key={a.id}
                  assignment={a}
                  onOpen={setSelectedAssignment}
                  onSubmit={handleOpenSubmit}
                />
              ))}
            </div>
          )}

          {view === "workflow" && (
            <div className="kanban-board">
              {KANBAN_COLUMNS.map((col) => (
                <KanbanColumn
                  key={col}
                  status={col}
                  assignments={ASSIGNMENTS.filter((a) => a.status === col)}
                  onOpen={setSelectedAssignment}
                  onSubmit={handleOpenSubmit}
                />
              ))}
            </div>
          )}
        </div>

        {/* Detail Modal */}
        {selectedAssignment && (
          <AssignmentModal
            assignment={selectedAssignment}
            onClose={() => setSelectedAssignment(null)}
            onSubmit={handleOpenSubmit}
          />
        )}

        {/* Submit Modal */}
        {submitAssignment && (
          <SubmitAssignmentModal
            assignment={submitAssignment}
            onClose={() => setSubmitAssignment(null)}
            onSubmitSuccess={(id) => {
              console.log("Assignment submitted:", id);
            }}
          />
        )}
      </div>
    </MyStudentLayout>
  );
}
